import { useAppSelector } from '../../../app/hooks';


interface MachineStatusDialProps {
    ElementName: string;
    Alias: string;
    attributeGuid: string;
}

export function MachineStatusDial(props: MachineStatusDialProps) {
    const attributes = useAppSelector((state) => state.attributesSlice.attributes);

    let isProducing = 0;
    if (props.attributeGuid && props.attributeGuid !== undefined) {
        var attributeValue = attributes.find(attribute => attribute.Guid === props.attributeGuid)?.Values[0];
        isProducing = attributeValue && typeof attributeValue.Value === 'string' ? Number(attributeValue.Value) : 0;
    }

    let color = isProducing === 1 ? "bg-good-green" : "bg-bad-red";

    return (
        <div>
            <div className="grid gap-0 columns-1 justify-center">
                <div className='flex justify-center items-center relative '>
                    <div className="text-center text-text-dark text-xl font-bold absolute">
                        {props.Alias ? props.Alias : "N/A"}
                    </div>
                    <div className={`${color} w-20 h-20 rounded-md border-slate-200`} />
                </div>
                <div className="text-center text-text-light dark:text-text-dark
                 pt-1 text-sm font-semibold">
                    {props.ElementName}
                </div>
            </div>
        </div>
    );

}